import React from 'react';
import styled from 'styled-components';
import { Images } from '../../../@resources/img';
import { Image } from '../../../concepts/resources/Image';
import { withXmas } from './WithXmas';

const Frame = styled.div`
    pointer-events: none;
    position: absolute;
    top: 0rem;
    left: 0;
    transform: translate(2.4rem, 1.05rem) scale(2.6, 2.4) rotate(-19deg);
    svg {
        width: 1rem;
    }
`;

export const XmasHat = withXmas(() => {

    return <Frame>
        <Image src={Images.SebXmasHat} />
    </Frame>;
});
